module.exports = __webpack_public_path__ + "static/scale-model-of-deep-creek-park-in-fremont-california-9b5c742009aa8201fdcb1eda526ba3d2.png";